export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/md5.worker.1790560550183.worker.js");
}
